import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ChatService, ChatStreamEvent } from './chat.service';
import { ServiceConstant } from '../utils/service-constant.util';

/**
 * WebSocket stream for restaurant common (non-insight) chats.
 * Endpoint: `/v1/restaurants/{restaurantId}/chats/{chatId}/stream?token={jwt}`
 */
@Injectable({
  providedIn: 'root',
})
export class CommonChatService {
  private readonly chatService = inject(ChatService);

  get isConnected(): boolean {
    return this.chatService.isConnected;
  }

  get isActive(): boolean {
    return this.chatService.isActive;
  }

  /**
   * Listen for streamed assistant messages on the common chat WebSocket.
   */
  connect(restaurantId: string, chatId: string): Observable<ChatStreamEvent> {
    const path = `${ServiceConstant.apiPrefix}/restaurants/${restaurantId}/chats/${chatId}/stream`;
    return this.chatService.connectStream(path);
  }

  disconnect(): void {
    this.chatService.disconnect();
  }

  send(payload: unknown): void {
    this.chatService.send(payload);
  }
}
